import {createContext,useContext,useState} from "react";

export const CategoryFilterContext = createContext();

export const CategoryFilterProvider = ({children}) => {
    const [selectedSubCategoryId,setSelectedSubCategoryId] = useState("");
     const [selectedInsitutionCategoryId, setSelectedInsitutionCategoryId] = useState("");
      const[selectedCategoryId,setSelectedCategoryId]=useState("")
  
    return (
        <CategoryFilterContext.Provider value={{selectedSubCategoryId,setSelectedSubCategoryId,selectedInsitutionCategoryId,setSelectedInsitutionCategoryId,selectedCategoryId,setSelectedCategoryId}}>
           {children}
        </CategoryFilterContext.Provider>
    )
};
export const useCategoryFilter = () => useContext(CategoryFilterContext);
